/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import { CardHover as PdtBlock } from "./CardHover";
import { connect } from "react-redux";

class PdtBlockList extends React.Component {
  render() {
    const { products} = this.props;
    return (
      (products &&
        products.map((product, index) => (
          <div key={index} className="swiper-slide">            
            <PdtBlock product={product} />
          </div>
        ))) ||
      null
    );
  }
}

const mapStateToProps = state => {
  return {
    productLoading: state.product.loading
  };
};
export default connect(mapStateToProps)(PdtBlockList);
